import {withTranslation} from "react-i18next";
import React from "react";
import Slider from "react-slick";
import {slickDot2} from "../page-demo/script";
const ProductsLeft = (props) =>{

    return (
        <React.Fragment>
            <div className="col-lg-12">
                <div className="service-details-inner">
                    <div className="inner">
                        {/* Start Single Area */}
                        <div className="row sercice-details-content   align-items-center">

                            <div className="col-lg-8 col-12">
                                <div className="details mt_md--30 mt_sm--30">
                                    <h4 className="title">{props.title}</h4>
                                    <p dangerouslySetInnerHTML={{__html: props.description1} }/>
                                    <p dangerouslySetInnerHTML={{__html: props.description2} }/>
                                    <p dangerouslySetInnerHTML={{__html: props.description3} }/>
                                </div>
                            </div>
                            <div className="col-lg-4 col-12">
                                <div className="slick-space-gutter--0 slickdot--20">
                                    <Slider {...slickDot2}>
                                        {props.imagesList.map((value , index) => (
                                            <div
                                                className="portfolio" key={index}>
                                                <div className="thumbnail-inner">
                                                    <div className={`thumbnail ${value.image}`} style={{backgroundImage: `url("${value.image}")`}}></div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                        {/* End Single Area */}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(ProductsLeft);

